/**
 * Created by Ning Jiang on 12/4/2019.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";
import {DeadwoodReelSymbol} from "./DeadwoodReelSymbol";

export class DeadwoodScatterSymbol extends DeadwoodReelSymbol {

    private _backFireSprite:PIXI.Sprite;
    private _backFireBg:PIXI.Sprite;
    private _backFireSpine:PIXI.spine.Spine;
    private _fireTailSprite:PIXI.Sprite;
    private _fireTailSpine:PIXI.spine.Spine;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected initAnimations():void {
        this._fireTailSprite = new PIXI.Sprite();
        this._fireTailSprite.anchor.set(0.5);
        this._fireTailSprite.alpha = 0;
        this.addChild(this._fireTailSprite);

        this._backFireSprite = new PIXI.Sprite();
        this._backFireSprite.anchor.set(0.5);
        this._backFireSprite.alpha = 0;
        this.addChild(this._backFireSprite);

        this._backFireBg = new PIXI.Sprite(GameResources.getTextures("scatterFireBg")[0]);
        this._backFireBg.anchor.set(0.5);
        this._backFireBg.scale.set(4);
        this._backFireSprite.addChild(this._backFireBg);
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        const result:boolean =  super.initState(stateConfig);

        this.addChild(this._fireTailSprite);

        return result;
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === DeadwoodGameConfig.instance.SYMBOL_STATES.landing.keyword) {
            const fireTl:TimelineLite = new TimelineLite();
            fireTl.add([
                () => {
                    if(!this._backFireSpine) {
                        this._backFireSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterAttention_fireToggle"));
                        this._backFireSpine.autoUpdate = true;
                        this._backFireSprite.addChild(this._backFireSpine);
                    }
                    this._backFireSpine.state.clearTrack(0);
                    this._backFireSpine.skeleton.setToSetupPose();
                    this._backFireSpine.state.setAnimation(0, "scatterAttention_fireToggle", false);
                },
                TweenLite.to(this._backFireSprite, 0.1, {alpha : 1})
            ]);

            timeline.add([fireTl], delay);
        }

        if(newState.state.keyword === DeadwoodGameConfig.instance.SYMBOL_STATES.spinAttention.keyword) {
            const tailTl:TimelineLite = new TimelineLite();
            tailTl.add([
                () => {
                    if(!this._fireTailSpine) {
                        this._fireTailSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatter_Tail"));
                        this._fireTailSpine.autoUpdate = true;
                        this._fireTailSprite.addChild(this._fireTailSpine);
                    }
                    this._fireTailSpine.state.clearTrack(0);
                    this._fireTailSpine.skeleton.setToSetupPose();
                    this._fireTailSpine.state.setAnimation(0, "scatter_Tail", false);
                },
                TweenLite.to(this._fireTailSprite, 0.1, {alpha : 1})
            ]);

            timeline.add(tailTl, delay);
        } else {
            timeline.add(TweenLite.to(this._fireTailSprite, 0.1, {
                alpha : 0, onComplete : () => {
                    if(this._fireTailSpine && this._fireTailSpine.state) {
                        this._fireTailSpine.state.setEmptyAnimation(0, 0);
                    }
                }
            }), delay);
        }
    }

    public stopBackFire():void {
        TweenLite.to(this._backFireSprite, 0.5, {
            alpha : 0, onComplete : () => {
                if(this._backFireSpine) {
                    this._backFireSpine.state.setEmptyAnimation(0, 0);
                }
            }
        });
    }
}